import React from 'react';
import i18n from 'app/common/lib/i18n';
import loadable from '@loadable/component';
import { Box, Spinner } from 'gestalt';

const InternalHybridHelper = loadable(() =>
  import(/* webpackChunkName: "InternalHybridHelper" */ 'app/common/react/components/growth/unauth/internal/InternalHybridHelper/InternalHybridHelper'),
);

export default function InternalHybridHelperLoader(props) {
  const fallback = (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Spinner
        accessibilityLabel={i18n._(
          'Loading Internal Hybrid Helper',
          'accessibility label for loading spinner',
        )}
        show
      />
    </Box>
  );
  return <InternalHybridHelper {...props} fallback={fallback} />;
}
